import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { siteConfig } from './config/site'

// Atualiza o título e meta tags dinamicamente com base no site ativo
document.title = siteConfig.metaTitle || siteConfig.name;
const metaDesc = document.querySelector('meta[name="description"]');
if (metaDesc) metaDesc.setAttribute('content', siteConfig.metaDescription || siteConfig.description);
const ogTitle = document.querySelector('meta[property="og:title"]');
if (ogTitle) ogTitle.setAttribute('content', siteConfig.metaTitle || siteConfig.name);
const ogDesc = document.querySelector('meta[property="og:description"]');
if (ogDesc) ogDesc.setAttribute('content', siteConfig.metaDescription || siteConfig.description);
const canonical = document.querySelector('link[rel="canonical"]');
if (canonical) canonical.setAttribute('href', `https://www.${siteConfig.domain}/`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
